import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink } from "react-router-dom";

function BrandMark({ className = "" }) {
  return (
    <svg
      className={`brand-mark ${className}`.trim()}
      viewBox="0 0 40 44"
      width="36"
      height="40"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="brandHexStroke" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#01bf71" />
          <stop offset="48%" stopColor="#01bf71" />
          <stop offset="52%" stopColor="#e8f7f0" />
          <stop offset="100%" stopColor="#e8f7f0" />
        </linearGradient>
      </defs>
      <path
        className="brand-mark-hex"
        d="M20 2.2L36.2 11.4V32.6L20 41.8L3.8 32.6V11.4L20 2.2Z"
        fill="rgba(255,255,255,0.08)"
        stroke="url(#brandHexStroke)"
        strokeWidth="2.4"
        strokeLinejoin="round"
      />
      <text
        className="brand-mark-letter"
        x="20"
        y="28"
        textAnchor="middle"
        fontSize="16"
        fontWeight="700"
        fontFamily="Space Grotesk, sans-serif"
        fill="#ffffff"
      >
        D
      </text>
    </svg>
  );
}

/**
 * Site lockup: hex mark + Dblog / Computer Solutions.
 */
function BrandLogo({ to = "headerbg", home = false, onClick }) {
  const content = (
    <>
      <BrandMark />
      <span className="brand-lockup-text">
        <span className="brand-lockup-name">Dblog</span>
        <span className="brand-lockup-tag">Computer Solutions</span>
      </span>
    </>
  );

  if (home) {
    return (
      <RouterLink to="/" className="brand-lockup" onClick={onClick} aria-label="Dblog Computer Solutions">
        {content}
      </RouterLink>
    );
  }

  return (
    <ScrollLink
      spy={true}
      smooth={true}
      duration={800}
      to={to}
      className="brand-lockup"
      style={{ cursor: "pointer" }}
      onClick={onClick}
      aria-label="Dblog Computer Solutions"
    >
      {content}
    </ScrollLink>
  );
}

export default BrandLogo;
export { BrandMark };
